const h3 = () => `h3 {
  font-weight: 500;
  font-size: 32px;
  line-height: 48px;
}
`;

const h4 = () => `h4 {
  font-weight: 500;
  font-size: 28px;
  line-height: 44px;
}
`;

const h5 = () => `h5 {
  font-weight: 500;
  font-size: 24px;
  line-height: 40px;
}
`;

export const styles = () => `
${h3()}
${h4()}
${h5()}`;
